module.exports = __webpack_public_path__ + "static/assets/6626497c5be0257fa64f38d0fddda525.png";